"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
/* eslint-disable valid-jsdoc */
/* eslint-disable guard-for-in */
/* eslint-disable no-empty */
/* eslint-disable no-empty-function */
/* eslint-disable no-unused-vars */
/* eslint-disable sort-imports */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelParserStatic = void 0;
const parserCollection_1 = require("./parserCollection");
class ModelParserStatic {
    static parseObject(model, objectPropertyInfoList, elementPropertyConstraints, aggregateContext, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    parsingErrors, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    object) {
        parserCollection_1.ParserCollection.EntityInfoParser.parseObject(model, objectPropertyInfoList, elementPropertyConstraints, [], aggregateContext, parsingErrors, object, undefined, undefined, undefined, undefined, undefined, true, true, false, new Set());
    }
}
exports.ModelParserStatic = ModelParserStatic;
//# sourceMappingURL=modelParserStatic.js.map